export default "__VITE_ASSET__BU75_e6g__"